import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import FeaturesSection from './components/FeaturesSection';
import TeamSection from './components/TeamSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '性事咨询员',
    url: 'https://xingshizixun.com',
    description: '专业两性健康咨询服务平台，提供私密、温暖的一对一专业咨询服务',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://xingshizixun.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '性事咨询员',
    url: 'https://xingshizixun.com',
    description: '专业两性健康咨询服务平台',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-XXXX',
      contactType: 'customer service',
      availableLanguage: 'Chinese',
    },
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '性事咨询员 - 首页',
    description: '性事咨询员提供专业、私密的两性健康咨询服务，涵盖性健康教育、亲密关系指导、性功能困扰解答等。',
    url: 'https://xingshizixun.com',
    isPartOf: {
      '@type': 'WebSite',
      name: '性事咨询员',
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageSchema) }}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection />
        <FeaturesSection />
        <TeamSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}